import { useEffect, useState } from 'react';
import Typography from '@alltrails/core/components/Typography';
import { getNlSuggestions } from '../../../requests/nlSearchRequests';
import NlSearchResult from './NlSearchResult';
import NlSearchSuggestions from './NlSearchSuggestions';
import styles from './NlSearchModule.module.scss';

type Props = {
  handleOnAiSearch: (text: string) => void;
  query: string;
  isActive?: boolean;
};

const NlSearchModule = ({ handleOnAiSearch, query, isActive }: Props) => {
  const showSearchResult = query?.length > 0;
  const [isLoading, setIsLoading] = useState(true);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    async function fetchSuggestions() {
      try {
        const response = await getNlSuggestions();
        setSuggestions(response.suggestions);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchSuggestions();
  }, []);

  const title = showSearchResult ? 'Search for' : 'Try searching';

  return (
    <div className={styles.container}>
      <Typography className={styles.header} variant="text200bold" component="h3">
        {title}:
      </Typography>
      {showSearchResult ? (
        <NlSearchResult query={query} handleOnAiSearch={() => handleOnAiSearch(query)} isActive={isActive} />
      ) : (
        <NlSearchSuggestions handleOnAiSearch={handleOnAiSearch} isLoading={isLoading} suggestions={suggestions} />
      )}
    </div>
  );
};

export default NlSearchModule;
